import Blockly from 'blockly/browser'
import { defineBlock } from './Util'
import Mutators from './Mutators'
import './Api/Index'
import './javascriptBlocks/Index'

// This file serves as the main entrypoint for loading our custom blockly blocks
defineBlock(
  'sirenia_api_guid_get',
  {
    message0: 'new Guid',
    output: 'String',
    tooltip: 'Guid.get()',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#guid'
  },
  function(block) {
    var code = 'Guid.get()'
    return [code, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

//
// Register some reusable mutators
//

Mutators.registerOptionsMutator('sirenia_reflection_depth_mutator', {
  reflectionDepth: {
    type: 'Number',
    label: 'reflection depth'
  }
})

Mutators.registerOptionsMutator('sirenia_deadline_mutator', {
  deadline: {
    type: 'Number',
    label: 'deadline (ms)'
  }
})

Mutators.registerOptionsMutator('sirenia_delay_mutator', {
  delay: {
    type: 'Number',
    label: 'delay (ms)'
  }
})

Mutators.registerOptionsMutator('sirenia_reflection_depth_deadline_mutator', {
  reflectionDepth: null,
  deadline: null
})
